/**
Copyright (C) 2019-2025, Infraclear Inc. All Rights Reserved.
*/

import instance from '../../../utils/axiosInstance';
import {
  AdminApiKeys,
  AdminApiKeysRotate,
  AdminApiKeysRevoke,
} from '../../../constants/api-urlConstants';
import {
  ApiKey,
  IssueApiKeyPayload,
  IssueApiKeyResponse,
  RotateApiKeyPayload,
  RevokeApiKeyPayload,
} from './types';

export const fetchApiKeys = (organizationName: string): Promise<ApiKey[]> => {
  return instance
    .get(AdminApiKeys, { params: { organizationName } })
    .then((response) => response.data.data ?? response.data);
};

export const issueApiKey = (payload: IssueApiKeyPayload): Promise<IssueApiKeyResponse> => {
  return instance
    .post(AdminApiKeys, payload)
    .then((response) => response.data.data ?? response.data);
};

export const rotateApiKey = (payload: RotateApiKeyPayload): Promise<IssueApiKeyResponse> => {
  return instance
    .post(AdminApiKeysRotate, payload)
    .then((response) => response.data.data ?? response.data);
};

export const revokeApiKey = (payload: RevokeApiKeyPayload): Promise<void> => {
  return instance
    .post(AdminApiKeysRevoke, payload)
    .then(() => undefined);
};
